import { SetRoutes } from 'components';
import routes from './routes';

const NotificationGroupsPages = () => {
  return (
    <>
      <SetRoutes routes={routes} />
    </>
  );
};

export default NotificationGroupsPages;
